/* ---------------------------------------------------------------------
 *                           Import Library
 * --------------------------------------------------------------------- */

// utils
import { get } from "./api";
import { CHAT_PATH } from "../utils/constants";
import { processStreamData } from "../utils/utilities";

/* ---------------------------------------------------------------------
 *                               Chat API
 * --------------------------------------------------------------------- */

/**
 * 获取AI聊天回答数据
 * @param {object} data - 表单数据
 * @param {string} data.message - 问题
 * @returns {string}  - 聊天回答
 */
export async function getChatStream(data) {
    try {
        const response = await get(CHAT_PATH, data);
        const resChatData = processStreamData(response);

        return {
            success: true,
            message: '获取聊天记录成功',
            data: resChatData
        }
    } catch (error) {
        // 返回后端错误信息或默认错误
        const message = error?.response?.data?.message || error.message || "获取聊天对话失败";
        return { success: false, message };
    }
}